import Vue from "vue";
import App from "./App.vue";
import VueI18n from 'vue-i18n';

import en from './locales/en';
import mn from './locales/mn';
import ru from './locales/ru';
import cn from './locales/cn';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'mn', // Set default language
  fallbackLocale: 'mn', // Fallback language if translation is missing
  messages: {
    en,
    mn,
    ru,
    cn,
  },
});

import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import VCalendar from 'v-calendar';

//import { createRoute, localSave, localRead } from "@/libs/util";
import { getConfigValueByKey } from "@/libs/util";

import { formatMoney, formatDateYMD, formatDateY } from "@/libs/tools";

import VueHtmlToPaper from "vue-html-to-paper";

const printOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://res.gosmart.mn/css/iview.css",
    "https://res.gosmart.mn/css/gosmart.css",
    "https://res.gosmart.mn/css/suisbatlamtprint.css",
    "https://res.gosmart.mn/css/inDocCard.css",
    "https://res.gosmart.mn/css/store.css"
  ]
};

Vue.use(VueHtmlToPaper, printOptions);

Vue.config.productionTip = false;

const moment = require("moment");
require("moment/locale/mn");

Vue.use(require("vue-moment"), {
  moment
});

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

Vue.use(Viewer);

import VueYoutube from "vue-youtube";
Vue.use(VueYoutube);

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import VueFullPage from "vue-fullpage.js";
Vue.use(VueFullPage);

import lang from "element-ui/lib/locale/lang/mn";
import locale from "element-ui/lib/locale";
locale.use(lang);

 import "bootstrap/dist/css/bootstrap.min.css";
 import "bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/scss/dashforge.scss";
// import "./assets/scss/overrides/_golomt.scss";
// import "./assets/scss/overrides/_mmse.scss";
//  import "./assets/scss/overrides/_monicpa.scss";   
// import "./assets/scss/overrides/_educate.scss";
// import "./assets/scss/overrides/_gov.scss";
// import "./assets/scss/overrides/_mvma.scss";
// import "./assets/scss/overrides/_state.scss"; //# surgalt.gov
//  import "./assets/scss/overrides/_transbank.scss"; //# trans bank
//  import "./assets/scss/overrides/_capitronbank.scss"; //# capitron bank
// import "./assets/scss/overrides/_jud.scss"; //# edu.judcounsil.mn
// import "./assets/scss/overrides/_stf.scss";
// import "./assets/scss/overrides/_stfdoctor.scss";
// import "./assets/scss/overrides/_stfresearcher.scss";
// import "./assets/scss/overrides/_stfstartup.scss"; //# garaanii compani
// import "./assets/scss/overrides/_bizguide.scss";
// import "./assets/scss/overrides/_orchlon.scss";

 //# UBTZ youth
// import "./assets/scss/overrides/_youth.scss";
// import './assets/css/ubtz/bootstrap.css';
// import './assets/css/ubtz/css2.css';
// import './assets/css/ubtz/nemelt.css';
 //# UBTZ youth

// import "./assets/scss/overrides/_greengroup.scss";
// import "./assets/scss/skins/dark.scss";
// import "./assets/scss/overrides/_bfa.scss"; //# e.bfa.mn
//import "./assets/scss/overrides/_icer.scss"; //# edu-icer

//// import VueTailwind from 'vue-tailwind'
//// Vue.use(VueTailwind)
//import "./assets/scss/tailwind.scss";

import Affix from 'vue-affix';
Vue.use(Affix);

var _ = require("lodash");

Vue.filter('formatDateY', function (value) {
  return formatDateY(value);
});

Vue.filter("formatMoney", function(n, c, d, t) {
  return formatMoney(n, c, d, t);
});

Vue.filter('formatDateYMD', function (v, c) {
  return formatDateYMD(v, c);
});

Vue.filter('getConfigValueByKey', function (v, c, rv) {
  return getConfigValueByKey(c, v, rv);
});

Vue.filter("stripHtml", function(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
});

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyAKBeucCeOx81Zn5BvIXPS9WsERKOIH1hU",
    key: "AIzaSyDzsxSZMJtNwaB58sCqSZNKFoOp0Ebe7pE",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing,visualization'
  },
  installComponents: true
});

import VueFeather from "vue-feather";

//if(window.localStorage.getItem("mobileApp") != undefined){
import "./registerServiceWorker";
//}

Vue.use(VueFeather);

// Import particles.js globally for compatibility with Vue 2.6.12
import 'particles.js';

// import VCalendar from 'v-calendar';
// Vue.use(VCalendar, {
//   componentPrefix: 'vc',
// });

import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

// Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);


Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  //...,                // ...other defaults
});

import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);




window.Vue=Vue;

new Vue({
  i18n,
  store,
  vuetify,
  _,
  router,

  created() {
  },
  render: h => h(App)
}).$mount("#app");
